"use client";

import React from "react";
import { Heading } from "@/components/ui/typography";
import Image from "next/image";

export default function Framework({ heading = "Our Team" }: { heading?: string } = {}) {
  return (
    <section className="w-full bg-black  pb-[60px]  lg:pb-[120px] px-4 min-[1340px]:px-0">
      <div className="relative max-w-[1200px] mx-auto flex flex-col lg:flex-row items-center justify-between max-sm:gap-16 gap-10">
        {/* CONTENT */}
        <div className="w-full lg:flex-1 flex flex-col gap-8">
          {/* TITLE + TEXT */}
          <div className="flex flex-col gap-6">
            <Heading as="h2" variant="section">
              {heading}
            </Heading>

            <p className="text-[16px] font-normal sm:text-[16px] leading-6 text-white/70 font-inter">
              MuteTaxes is powered by a team of consultants, accountants,
              compliance specialists, and operators focused on one thing:
              Helping founders structure smarter. From financial planning and
              bookkeeping to offshore coordination and compliance support, our
              team works behind the scenes to ensure every client setup runs
              smoothly from start to finish.
            </p>
          </div>
        </div>

        {/* IMAGE BLOCK (NOW RESPONSIVE + ALWAYS VISIBLE) */}
        <div className="w-full lg:flex-1 relative h-[250px] sm:h-[380px] md:h-[450px] lg:h-[482px] max-sm:rounded-[16px] rounded-[30px] ">
          <Image
            src="/about/framework.webp"
            alt="Hero Visual"
            fill
            className="object-cover rounded-[30px]"
            priority
          />
        </div>
      </div>
    </section>
  );
}
